import { Extension, SelectorHandler, StyleSheet } from 'aphrodite';
import { Classes } from 'react-modal';

export const overlayTransitionTimeInMs = 300;
const contentTransition = 'all 0.45s cubic-bezier(0.23, 1, 0.32, 1) 0ms';

const globalSelectorHandler: SelectorHandler = (
	selector: string,
	_: string,
	generateSubtreeStyles: (selector: string) => string
) => {
	if (selector[0] !== '*') {
		return null;
	}

	return generateSubtreeStyles(selector.slice(1));
};

const globalSelectorExtension: Extension = {
	selectorHandler: globalSelectorHandler,
};

const { StyleSheet: StyleSheetExt, css: cssExt } = StyleSheet.extend([globalSelectorExtension]);

export const css = cssExt;

export const overlayClasses: Classes = {
	afterOpen: 'modal-overlay--after-open',
	base: 'modal-overlay',
	beforeClose: 'modal-overlay--before-close',
};

export const contentClasses: Classes = {
	afterOpen: 'modal-content--after-open',
	base: 'modal-content',
	beforeClose: 'modal-content--before-close',
};

export const styleSheet = StyleSheetExt.create({
	modal: {
		bottom: 0,
		display: 'none',
		left: 0,
		position: 'fixed',
		right: 0,
		top: 0,
		[`*.${contentClasses.base}`]: {
			':focus': {
				outline: 'none',
			},
			background: '#FFFFFF',
			border: '1px solid #BABABA',
			boxShadow: '0 2px 6px 0 rgba(0,0,0,0.20)',
			boxSizing: 'border-box',
			maxWidth: 900,
			minHeight: 160,
			minWidth: 360,
			opacity: 0,
			padding: 20,
			transform: 'translate(0, -50%)',
			transition: contentTransition,
		},
		[`*.${contentClasses.base}.${contentClasses.afterOpen}`]: {
			opacity: 1,
			transform: 'none',
			transition: contentTransition,
		},
		[`*.${contentClasses.base}.${contentClasses.beforeClose}`]: {
			opacity: 0,
			transform: 'translate(0, -50%)',
			transition: contentTransition,
		},
		[`*.${overlayClasses.base}`]: {
			alignItems: 'center',
			background: 'transparent',
			display: 'flex',
			height: '100%',
			justifyContent: 'center',
			overflowY: 'auto',
			transition: `${overlayTransitionTimeInMs}ms`,
			width: '100%',
		},
		[`*.${overlayClasses.base}.${overlayClasses.afterOpen}`]: {
			background: 'rgba(255,255,255,0.80)',
			transition: `${overlayTransitionTimeInMs}ms`,
		},
		[`*.${overlayClasses.base}.${overlayClasses.beforeClose}`]: {
			background: 'transparent',
			transition: `${overlayTransitionTimeInMs}ms`,
		},
	},
	modalActive: {
		display: 'block',
	},
});
